<template>
  <div id="pers-tab7" name="hres31x-tab7" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableExpWork.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-laptop icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC7']['10'] }} ( {{ labels['HRES31XC7']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desnoffi }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.deslstjob1 }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.deslstpos }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dtestart) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['70'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dteend) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['80'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desres }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['90'] }}</div>
              <div class="col-xs-6 data-text">{{ value.wrk_location }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['100'] }}</div>
              <div class="col-xs-6 data-text">{{ value.telnum }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['110'] }}</div>
              <div class="col-xs-6 data-text">{{ value.leader }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['120'] }}</div>
              <div class="col-xs-6 data-text">{{ value.salnow }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC7']['130'] }}</div>
              <div class="col-xs-6 data-text">{{ value.remark }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab7',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab7.vue?4016f51c